$(document).ready(function() {
    const amountScrolled = 100;
    let lastScrollTop = 0;
    let last = 0;
    $(window).scroll(function(){
        let scrollTop = $(this).scrollTop();
        if(scrollTop === 0){
            $('button.back-to-top').removeClass('show');
        } else {
            $('button.back-to-top').addClass('show');
        }
        lastScrollTop = scrollTop;
    });

    $('button.back-to-top').click(function() {
        $('html, body').animate({
            scrollTop: 0
        }, 600);
        return false;
    });

    // Contact buttons o the right side on desktop
    $('.floating').hover(function () {
        let id = $(this).attr("id");
        $('#' + id + '-content').toggleClass("hidden");
    });
});